module.exports = __webpack_public_path__ + "img/341-2b5481.png";